import styled from 'styled-components/macro'

import { getToken } from '@loadsmart/loadsmart-ui/dist/theming'

import { Price } from './Price'

export const StrikeThroughPrice = styled(Price)`
  text-decoration: line-through;
  color: ${getToken('color-neutral')};
  font-size: ${({ $size }) =>
    $size === 'large' ? getToken('font-size-2') : getToken('font-size-3')};
`
